import * as React from "react";
const SvgNavigation20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M-.294 7.656 19.856.174 12.34 20.283l-2.658-9.966-9.977-2.66Zm6.588-.313 5.023 1.34 1.342 5.034L16.45 3.572 6.294 7.343Z",
      clipRule: "evenodd"
    })
  );
export default SvgNavigation20Px;
